
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { useFormContext } from 'react-hook-form';

const currencyOptions = [
    { value: "USD", label: "$ USD" },
    { value: "EUR", label: "€ EUR" },
    { value: "GBP", label: "£ GBP" },
    { value: "CAD", label: "$ CAD" },
];



const DealAmountField = () => {
    const useFormReturn = useFormContext();
    const { control, watch } = useFormReturn;
    const { currency } = watch();


    return (
        <div className="grid grid-cols-[1fr_130px] gap-2.5">
            <FormField
                control={control}
                name="amount"
                render={({ field }) => (
                    <FormItem>
                        <FormLabel className="mb-2 block text-[10.5px] font-medium uppercase tracking-[0.12em] text-slate-500">
                            Amount
                        </FormLabel>
                        <FormControl>
                            <div className="relative">
                                <span className="absolute left-3 top-1/2 -translate-y-1/2 text-[12px] text-slate-500">$</span>
                                <Input
                                    placeholder="Enter amount"
                                    min={0}
                                    {...field}
                                    type="number"
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        if (value === "") {
                                            field.onChange(undefined);
                                        } else {
                                            field.onChange(Math.max(0, parseFloat(value)));
                                        }
                                    }}
                                    className="h-10 rounded-xl border-white/[0.06] bg-white/[0.02] pl-7 pr-3 text-[12.5px] text-slate-200 placeholder:text-slate-500 focus:border-brand-500/40 focus-visible:ring-0 focus-visible:ring-offset-0"
                                />
                            </div>
                        </FormControl>
                        <FormMessage className="text-[10.5px] text-accent-red" />
                    </FormItem>
                )}
            />

            <FormField
                control={control}
                name="currency"
                render={({ field }) => (
                    <FormItem>
                        <FormLabel className="mb-2 block text-[10.5px] font-medium uppercase tracking-[0.12em] text-slate-500">Currency</FormLabel>
                        <FormControl>
                            <Select onValueChange={field.onChange} value={currency}>
                                <SelectTrigger className="h-10 rounded-xl border-white/[0.08] bg-white/[0.02] text-[12.5px] text-slate-200">
                                    <SelectValue placeholder="$ USD" />
                                </SelectTrigger>
                                <SelectContent className="rounded-xl border-white/[0.08] bg-ink-800/95 text-slate-200 shadow-card backdrop-blur-xl">
                                    {currencyOptions.map((curr) => (
                                        <SelectItem
                                            key={curr.value}
                                            value={curr.value}
                                            className="text-[12.5px]"
                                        >
                                            {curr.label}
                                        </SelectItem>
                                    ))}
                                </SelectContent>
                            </Select>
                        </FormControl>
                        <FormMessage className="text-[10.5px] text-accent-red" />
                    </FormItem>
                )}
            />
        </div>
    )
}

export default DealAmountField
